import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import omit from 'lodash.omit';
import isString from 'lodash.isstring';
import Label from '../Label';
import styles from './SelectField.css';
import SelectArrow from '../../Icons/SelectArrow';
import getUniqueId from '../../../utils/getUniqueId';

const SelectField = ({
    input,
    label,
    options,
    className,
    style,
    selectClassName,
    selectWrapClassName,
    meta: { touched, error, warning },
    help,
}) => {
    let info;
    let infoClassName;
    if (touched && error) {
        infoClassName = styles.error;
        info = error;
    } else if (touched && warning) {
        infoClassName = styles.warn;
        info = warning;
    } else if (help) {
        infoClassName = styles.help;
        info = typeof help === 'function' ? help(input.value) : help;
    }
    const [selectId] = useState(input.id || getUniqueId('select-field'));
    const inputAriaProps = useMemo(() => {
        const { ariaLabel, ariaLabelledBy } = input;
        return (label || ariaLabelledBy)
            ? { 'aria-labelledby': label ? `${selectId}-label` : ariaLabelledBy }
            : {
                'aria-label': isString(ariaLabel) ? ariaLabel : 'Select a value',
            };
    }, [label, input]);
    return (
        <div className={cx(styles.selectWrap, className)} style={style}>
            {label ? (
                <Label id={`${selectId}-label`} text={label} htmlFor={selectId} />
            ) : null}
            <div className={cx(styles.wrap, selectWrapClassName)}>
                <select
                    className={cx(styles.select, selectClassName)}
                    {...omit(input, ['ariaLabel', 'ariaLabelledBy'])}
                    {...inputAriaProps}
                    value={input.value || 'default'}
                >
                    {options.map((option) => (
                        <option
                            key={option.key}
                            value={option.value}
                            disabled={option.value === 'default'}
                        >
                            {option.text}
                        </option>
                    ))}
                </select>
                <SelectArrow className={styles.arrow} />
            </div>
            {info ? (
                <span className={cx(styles.info, infoClassName)}>{info}</span>
            ) : null}
        </div>
    );
};

SelectField.propTypes = {
    options: PropTypes.array,
    input: PropTypes.object,
    meta: PropTypes.object,
    label: PropTypes.string,
    className: PropTypes.string,
    selectClassName: PropTypes.string,
    selectWrapClassName: PropTypes.string,
    style: PropTypes.object,
    help: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

SelectField.defaultProps = {
    value: '',
    options: [],
    meta: {},
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/SelectField/SelectField.js